import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Grid, IconButton, LinearProgress, Link, Menu, MenuItem, Select, Stack, Tooltip, Typography, useMediaQuery, useTheme, } from "@mui/material";
import { useState, useEffect } from "react";
import useAuth from "../../context/AuthProvider";
import InfoIcon from "@mui/icons-material/Info";
import EditIcon from "@mui/icons-material/EditOutlined";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import {
    DataGrid,
    DataGridProps,
    getGridStringOperators,
    GridCellParams,
    GridColDef,
    GridColumnMenuContainer,
    GridColumnMenuProps,
    GridColumnsMenuItem,
    GridFilterMenuItem,
    GridFilterModel,
    GridFilterOperator,
    GridRowId,
    GridRowModes,
    GridRowModesModel,
    GridSelectionModel,
    GridSortModel,
    GridToolbar,
    GridToolbarColumnsButton,
    GridToolbarContainer,
    GridToolbarExport,
    GridToolbarFilterButton,
    HideGridColMenuItem,
    SortGridMenuItems,
    // GridToolbarFilterButton,
} from "@mui/x-data-grid";
import { useNavigate, useParams } from "react-router-dom";
import { RiExpandUpDownLine } from "react-icons/ri";
import React from "react";
import { FMFilters, NewCompletedFilingsModel, getCompletedFilings__Resp, getPolicyFilingAndReport } from "../../models/NewCompletedFilingsModel";
import { AddDocument } from "../../CustomerPanel/AddDocuments";
import { PolicyDocumentsPopup } from "./PolicyDocumentsPopup";
import { PolicyErrorPopup } from "./PolicyErrorsPopup";
import { FaRegEdit } from "react-icons/fa";
import moment from "moment";
import { MenuDropdown } from "../../components/Elements/MenuDropdown";
import Swal from "sweetalert2";
import { DataGridPro, DataGridProProps, useGridApiRef } from "@mui/x-data-grid-pro";
import { FMTextField } from "../../components/Elements/input";
import FilerNotes from "../../components/Elements/filerNotes";
import { CustomerPolicyDetailsModel } from "../../models/CustomerPolicyDetailsModel";
import formatPrice from "../../helper/currencyFormatter";
import { formatUtcToLocal, mstDateStringToUtcIsoString } from "../../helper/utils";
import { PolicyStatuses } from "../../components/Elements/PolicyStatuses";
import { getRowsPerPageOptions } from "../../components/AddEdit/CustomFunctions";
import debounce from "lodash.debounce";
import Tabs, { FMTabs } from "../Tabs";
import { apiClient } from "../../helper/api";
import useAppDialog from "../../hooks/useAppDialog";
import { DialogResponse, DialogResult } from "../../components/Dialog/dialogTypes";
import { AppFlags } from "../../helper/config";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { KeyboardArrowUp, KeyboardArrowDown, FileDownload, Email } from "@mui/icons-material";

import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import { EditOutlined } from "@mui/icons-material";
import FilePresentOutlinedIcon from '@mui/icons-material/FilePresentOutlined';
import MoreVertOutlinedIcon from '@mui/icons-material/MoreVertOutlined';

interface Iprops {
    NewCompletedFilingsCL: getCompletedFilings__Resp;
    fetchFilingQueueData: (pageNumber: number, pageSize: number) => Promise<any>;
    closePolicy: (
        custPolicyId: number,
        action: string,
        value: number,
        message: string,
        isClosed: boolean
    ) => void;
    getCustomerPolicyListbyTaxType: (
        action: string,
        customerPolicyIds: number[],
        option: string
    ) => void;
    setSelectedRows: React.Dispatch<React.SetStateAction<NewCompletedFilingsModel[] | null>>
    selectedRows: NewCompletedFilingsModel[] | null
    getCustomerPolicyDetails: (customerPolicyIds: number) => Promise<string>;
    setCurrentPage: React.Dispatch<React.SetStateAction<number>>
    currentPage: number
    setPageSize: React.Dispatch<React.SetStateAction<number>>
    pageSize: number
    sortModel: any;
    filterModel: any;
    setFilterModel: React.Dispatch<React.SetStateAction<any>>;
    setSortModel: React.Dispatch<React.SetStateAction<any>>;
}

export const OutstandingFilings: React.FC<Iprops> = ({
    NewCompletedFilingsCL,
    fetchFilingQueueData,
    closePolicy,
    getCustomerPolicyListbyTaxType,
    setSelectedRows,
    selectedRows,
    getCustomerPolicyDetails,
    setCurrentPage,
    currentPage,
    setPageSize,
    pageSize,
    sortModel,
    filterModel,
    setFilterModel,
    setSortModel,
}) => {
    const { user } = useAuth();
    const token = user?.token;
    const { openDialog_Message } = useAppDialog()

    const theme = useTheme();
    const isTabletOrDown = useMediaQuery(theme.breakpoints.down('md'));

    const [loading, setloading] = useState(false);
    const navigate = useNavigate();
    const [Formdata, setFormData] = useState([]);
    const [Open, setOpen] = useState(false);
    const params = useParams();
    const [OpenError, setOpenError] = useState(false);
    const [editableSelectedRows, seteditableSelectedRows] = useState<NewCompletedFilingsModel[]>();
    const [ErrorFormdata, setErrorFormData] = useState([]);
    const [custPolId, setcustPolId] = React.useState("0");
    const [OpenDocResubmission, setDocResubmission] = React.useState(false);
    const [selectedRowStatus, setselectedRowStatus] = useState("");
    const [openNotesDialog, setOpenNotesDialog] = useState<string>('');
    const [openPolicyDueDateNullDialog, setOpenPolicyDueDateNullDialog] = useState(false);
    const [notes, setNotes] = useState<string>("");
    const [currentPolicySubStatus, setCurrentPolicySubStatus] = useState<string>('');
    const [rowModesModel, setRowModesModel] = React.useState<GridRowModesModel>({});
    const [CustPolicyNullDueDateData, SetCustPolicyNullDueDateData] = React.useState<any>();

    const [dataLoaded, setDataLoaded] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(true);

    const outstandingGridApiRef = useGridApiRef();
    const savedHorizontalScrollRef = React.useRef<number>(0);

    const statusOptions = ['Not Started', 'Waiting on Client']

    const getOutstandingStatusMenuSx = (status: string | null | undefined) => {
        const base = {
            height: 'auto',
            minHeight: 'unset',
            fontSize: '10px',
            padding: '1.75px 7px !important',
        } as const;
        const s = status ?? '';
        if (s === 'Filed' || s === 'Filed - Binder') {
            return {
                ...base,
                color: '#1b5e20',
                borderColor: '#2e7d32',
                backgroundColor: '#e8f5e9',
                '&:hover': { borderColor: '#1b5e20', backgroundColor: '#c8e6c9' },
            };
        }
        if (s === 'Waiting on Client') {
            return {
                ...base,
                color: '#f57f17',
                borderColor: '#fbc02d',
                backgroundColor: '#fffde7',
                '&:hover': { borderColor: '#f57f17', backgroundColor: '#fff9c4' },
            };
        }
        if (s === 'Not Started') {
            return {
                ...base,
                color: '#b71c1c',
                borderColor: '#c62828',
                backgroundColor: '#ffebee',
                '&:hover': { borderColor: '#b71c1c', backgroundColor: '#ffcdd2' },
            };
        }
        return { ...base };
    };

    // Action options
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const openMenuItem = Boolean(anchorEl);

    const handleClickOpenActionOptions = (customerPolicyId: number) => {
        const buttonEl = document.getElementById(`action-options-button-${customerPolicyId}`) as HTMLElement | null;
        setAnchorEl((prev) => (prev?.id === `action-options-button-${customerPolicyId}` ? null : buttonEl));
    };
    const handleCloseActionOptions = () => {
        setAnchorEl(null);
    };

    const handleOpenNotesDialog = (status: string) => {
        setOpenNotesDialog(status);
    };

    const handleCloseNotesDialog = () => {
        setOpenNotesDialog('');
    };

    const handleSubmitNotesDialog = (data: { notes: string }) => {

        console.log('Form data:', data);
        // Perform any action with the submitted data
        setNotes(data.notes)
        console.log('Form data:', notes);
        setOpenNotesDialog('');
    };

    const handleSubmitNotes = (data: { status: string, noteType: string, noteDetail: string, noteUser: string, firstRequestDate: string, secondRequestDate: string, thirdRequestDate: string, suspendedDate: string, noteDate?: string, policySubStatus?: string, dateDeclarationFiled?: string }) => {
        const { firstRequestDate, secondRequestDate, thirdRequestDate, suspendedDate, noteType, noteDetail, noteUser, noteDate, status, policySubStatus, dateDeclarationFiled } = data;
        setOpenNotesDialog('');
        updateStatus(status, selectedRows, noteDetail, noteUser, firstRequestDate, secondRequestDate, thirdRequestDate, suspendedDate, noteDate, policySubStatus, dateDeclarationFiled);
    };

    const handleDocumentReubmission = async (custPolId: number, status: string) => {
        try {
            setloading(true);
            setloading(false);
            setcustPolId(String(custPolId));
            setDocResubmission(true);

        } catch (error) {
            setloading(false);
            console.log(error);
        }
    };
    const handleSendMessage = async (custPolId: number, status: string) => {
        try {
            setloading(true);

            openDialog_Message({
                custPolId: String(custPolId)
            }).then((res: DialogResponse) => {
                if (res.dialogResult === DialogResult.OK) {
                    // Do something with the message

                    console.log('----- reload the updated data')
                    fetchFilingQueueData(currentPage, pageSize)

                }
                return res
            })
            setloading(false);

        } catch (error) {
            setloading(false);
            console.log(error);
        }
    };
    const onRowsSelectionHandler = (ids: GridSelectionModel | undefined) => {
        const selectedIDs = new Set(ids);
        const uniqueRowsIds = new Set();
        const selectedRowData = NewCompletedFilingsCL.getCompletedFilings_Respdata.filter((row) => {
            if (selectedIDs.has(row?.customerPolicyId ?? "") && !uniqueRowsIds.has(row?.customerPolicyId ?? "")) {
                uniqueRowsIds.add(row?.customerPolicyId ?? "");
                return true;
            }
            return false;
        });

        if (ids?.[0] != null || undefined) {
            setselectedRowStatus(
                NewCompletedFilingsCL.getCompletedFilings_Respdata.find((x) => x.customerPolicyId === Number(ids?.[0]))?.status ?? ""
            );
        } else {
            setselectedRowStatus("");
        }
        if (ids?.[0] != null || undefined) {
            setselectedState(
                NewCompletedFilingsCL.getCompletedFilings_Respdata.find((x) => x.customerPolicyId === Number(ids?.[0]))?.homeState ?? ""
            );
            setselectedTransactionType(
                NewCompletedFilingsCL.getCompletedFilings_Respdata.find((x) => x.customerPolicyId === Number(ids?.[0]))?.transactionTypeName ?? ""
            );
        } else {
            setselectedState("");
            setselectedTransactionType("");
        }

        setSelectedRows(selectedRowData);
    };

    const SumitToSLA = () => {

        var MultiplePolicyIds: string = selectedRows?.map((x) => x.customerPolicyId).join(",") ?? "";
        const readyToFileRows = selectedRows?.filter(row => row.status === "Ready to File");
        MultiplePolicyIds = readyToFileRows?.map(x => x.customerPolicyId).join(",") ?? "";


        Swal.fire({
            title: 'Confirmation!',
            text: 'You will not be able to submit this selected for rows that are not "Ready to File". Proceed anyway?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#02A4E3',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Proceed',
            customClass: {
                confirmButton: 'btn-radius',
                cancelButton: 'btn-radius',
                popup: 'card-radius'
            }
        }).then((result) => {
            if (result.isConfirmed) {

                if (MultiplePolicyIds === "") {
                    alert("Please Select at least one Filing or Policy id does not exist for selected Filing.");
                    return;
                }
                setloading(true);
                apiClient(`/SLIPSubmission/SubmitPolicyToState?custPolicyIdList=${MultiplePolicyIds}`,
                    {
                        method: "GET",
                        headers: new Headers({
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token}`,
                        }),
                    }
                )
                    .then((responseJson) => {
                        if (!responseJson) return

                        alert(responseJson.data);
                        if (MultiplePolicyIds === "") {
                            alert("Please Select at least one Filing");
                            return;
                        }
                    })
                    .finally(() => {
                        setloading(false);
                    });
            }
            else {
                setloading(false);
                return;
            }
        });

    };

    const handleSendEmail = () => {
        Swal.fire({
            title: 'Confirmation!',
            text: 'You can send email only for "Flagged" filing. Proceed anyway?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#02A4E3',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Proceed',
            customClass: {
                confirmButton: 'btn-radius',
                cancelButton: 'btn-radius',
                popup: 'card-radius'
            }
        }).then((result) => {
            if (result.isConfirmed) {
                if (!selectedRows || selectedRows.length === 0) {
                    // If no rows are selected, show a message to the user
                    alert("Please select row before sending an email");
                    return;
                }
                setloading(true);
                var MultiplePolicyIds: string = selectedRows?.map(x => x.customerPolicyId).join(",") ?? ""
                const FlaggedRows = selectedRows?.filter(row => row.status === "Flagged");
                MultiplePolicyIds = FlaggedRows?.map(x => x.customerPolicyId).join(",") ?? "";
                apiClient(`/ProcessPolicyChecks/SendChecksEmailMultiple?customerPolicyIdList=${MultiplePolicyIds}`,
                    {
                        method: "POST",
                        headers: new Headers({
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`,
                        })
                    })
                    .then((responseJson) => {
                        if (!responseJson) return
                        alert("Email sent");
                    }).finally(() => {
                        setloading(false);
                    });
            }
            else {
                setloading(false);
                return;
            }
        });

    };

    const handleExport = (option: string) => {
        var customerPolicyIds = selectedRows?.map(m => m.customerPolicyId) ?? [];
        getCustomerPolicyListbyTaxType("getCustomerPolicyListbyTaxType", customerPolicyIds, option);
    };

    const handleMultipleDownload = () => {
        var MultiplePolicyIds: string =
            selectedRows?.map((x) => x.policyId).join(",") ?? "";

        const readyToFileRows = selectedRows?.filter(row => row.status === "Ready to File");
        MultiplePolicyIds = readyToFileRows?.map(x => x.customerPolicyId).join(",") ?? "";

        Swal.fire({
            title: 'Confirmation!',
            text: 'You can download document only for "Ready to File" Filings. Proceed anyway?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#02A4E3',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Proceed',
            customClass: {
                confirmButton: 'btn-radius',
                cancelButton: 'btn-radius',
                popup: 'card-radius'
            }
        }).then((result) => {
            if (result.isConfirmed) {
                if (MultiplePolicyIds === "") {
                    alert("Please Select at least one Filing or Policy Id does not exist for selected Filing.");
                    return;
                }
                setloading(true);
                //call api to save data
                apiClient(`/PolicyFilings/getMultiplePolicyBatchSubmissionData?MultiplePolicyIds=${MultiplePolicyIds}`,
                    {
                        method: "POST",
                        headers: new Headers({
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token}`,
                        }),
                        // body: JSON.stringify(MultiplePolicyIds)  // <-- Post parameters
                    }
                )
                    .then((res) => {
                        if (!res) return

                        if (res.resp === 1) {

                            alert(res.message);
                            setloading(false);
                            return;
                        }
                        console.log(res.data, "readyTofiledata");
                        if (res.data != "") {

                            window.open(res.data, "_blank");
                            fetchFilingQueueData(currentPage, pageSize);

                        } else {
                            alert("Something went wrong");
                        }
                    })
                    .finally(() => {
                        setloading(false);
                    });
            }
            else {
                setloading(false);
                return;
            }
        });

    };

    const handleEdit = (custPolId: number) => {
        apiClient(`/PolicyDashBoard/getCustomerPolicyDocuments?CustPolicyId=${custPolId}`,
            {
                method: "GET",
                headers: new Headers({
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                }),
            }
        )
            .then((responseJson) => {
                if (!responseJson) return
                // Do something with the response
                console.log(responseJson);
                setFormData(responseJson.data);
            })

        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setOpenError(false);
        setDocResubmission(false);
        setOpenPolicyDueDateNullDialog(false);
        seteditableSelectedRows(undefined);
    };

    const handleCloseDocumentUpload = () => {
        setDocResubmission(false);
        void fetchFilingQueueData(currentPage, pageSize);
    };

    const [selectedState, setselectedState] = useState("");
    const [selectedTransactionType, setselectedTransactionType] = useState("");


    useEffect(() => {
        const newRowModesModel: { [key: number]: { mode: GridRowModes } } = {};
        NewCompletedFilingsCL?.getCompletedFilings_Respdata?.forEach((row) => {
            newRowModesModel[row.customerPolicyId] = { mode: GridRowModes.Edit };
        });
        setRowModesModel(newRowModesModel);
    }, []);

    useEffect(() => {
        // setIsLoading(true);
        // alert("NewCompletedFilingsCL: " + NewCompletedFilingsCL?.getCompletedFilings_Respdata.length);
        if (NewCompletedFilingsCL?.getCompletedFilings_Respdata.length > 0) {
            setDataLoaded(true);
        }
    }, [NewCompletedFilingsCL]);

    useEffect(() => {
        if (dataLoaded) {
            setIsLoading(false);
        }
    }, [dataLoaded]);

    const parseDueDate = (dueDateStr: string): Date => {
        const currentDate = new Date();
        const [month, day] = dueDateStr.split('-').map(Number);
        const year = currentDate.getFullYear();
        return new Date(year, month - 1, day);
    };

    const isDueDateWithinRange = (dueDateStr: string): boolean => {
        const currentDate = new Date();
        const dueDate = parseDueDate(dueDateStr);
        const dateDifference = dueDate.getTime() - currentDate.getTime();
        const dayDifference = dateDifference / (1000 * 3600 * 24);
        return dayDifference >= 0 && dayDifference <= 9;
    };
    var count = 0;
    const updateStatus = async (status: string, selectedRow: any, notes: string = '', filerName: string = '', firstRequestDate: string = '', secondRequestDate: string = '', thirdRequestDate: string = '', suspendedDate: string = '', noteDate?: string, policySubStatus: string = '', dateDeclarationFiled: string = '') => {
        setloading(true);
        if (noteDate === null || noteDate === '' || noteDate === undefined) {
            noteDate = formatUtcToLocal(new Date().toISOString(), "MM/DD/YYYY");
        }
        if (status === "Filed") {
            var customerPolicyIds = selectedRows?.map(m => m.customerPolicyId) ?? [];
            if (count === 0) {

                (async () => {
                    try {
                        const response = await getTaxTypeData('getIsPolicyFilingAndReportByCustPolIds', customerPolicyIds);

                        if (response != null && response.length > 0) {
                            const dueDateNotValid: NewCompletedFilingsModel[] = []; // where due date is not prior 10 days of due date
                            response.forEach((e: getPolicyFilingAndReport) => {
                                if (e.report == true) {
                                    var newData = selectedRows?.find(m => m.customerPolicyId == e.customerPolicyId);
                                    if (!isDueDateWithinRange(newData?.dueDate) && newData !== undefined) {
                                        dueDateNotValid.push(newData);
                                    }
                                }
                            });

                            const DueDateNotValid = new Set(dueDateNotValid.map(item => item.customerPolicyId));
                            const filteredSelectedIds = selectedRows?.filter(item => !DueDateNotValid.has(item.customerPolicyId!))
                            console.log("filteredSelectedIds :", filteredSelectedIds);
                            count++;
                            if (dueDateNotValid.length > 0) {
                                seteditableSelectedRows(filteredSelectedIds)
                                SetCustPolicyNullDueDateData(dueDateNotValid);
                                setOpenPolicyDueDateNullDialog(true);
                            }
                            else {
                                SetCustPolicyNullDueDateData(null);
                                setOpenPolicyDueDateNullDialog(false);
                                seteditableSelectedRows(undefined);
                                updateStatus("Filed", filteredSelectedIds, notes, filerName, firstRequestDate, secondRequestDate, thirdRequestDate, suspendedDate, noteDate, policySubStatus, dateDeclarationFiled);
                            }
                        }
                        setloading(false);
                        return;
                    } catch (error) {
                        console.error("Error fetching tax type data:", error);
                        return;
                    }
                })();
                return;
            }
        }
        setOpenPolicyDueDateNullDialog(false);

        const res = await apiClient(`/PolicyDashBoard/updateCustomerPolicyStatus?status=${status}&&notes=${notes}&&filerName=${user?.userFirstName + ' ' + user?.userlastName}&&filerDate=${encodeURIComponent(mstDateStringToUtcIsoString(noteDate))}&&firstRequestDate=${encodeURIComponent(mstDateStringToUtcIsoString(firstRequestDate))}&&secondRequestDate=${encodeURIComponent(mstDateStringToUtcIsoString(secondRequestDate))}&&thirdRequestDate=${encodeURIComponent(mstDateStringToUtcIsoString(thirdRequestDate))}&&suspendedDate=${encodeURIComponent(mstDateStringToUtcIsoString(suspendedDate))}&&policySubStatus=${policySubStatus}&&dateDeclarationFiled=${dateDeclarationFiled}`, {
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            }),
            body: JSON.stringify(selectedRow)
        }, {
            message: `Update the Customer Policy status to '${status}'.`
        })
        if (!res) return
        if (res !== null && res !== undefined) {
            Swal.fire({
                title: res.resp === 1 ? 'Error' : 'Success',
                text: res.message,
                icon: res.resp === 1 ? 'error' : 'success',
                confirmButtonColor: '#02A4E3',
                confirmButtonText: 'OK',
                customClass: {
                    confirmButton: 'btn-radius',
                    cancelButton: 'btn-radius',
                    popup: 'card-radius'
                }
            }).then((result) => {
                setSelectedRows([]);

                fetchFilingQueueData(currentPage, pageSize);
            })
        }
        
        setloading(false);
    }

    const getTaxTypeData = async (action: string, customerPolicyIds: number[]) => {
        const initValueExport = {
            customerPolicyIds: customerPolicyIds,
            option: ''
        };

        const res = await apiClient(`/PolicyDashBoard/${action}`,
            {
                method: "POST",
                headers: new Headers({
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                }),
                body: JSON.stringify(initValueExport)
            }
        );

        if (res?.data != null) {
            return res.data;
        }
    };

    const initialdata: NewCompletedFilingsModel = {
        customerPolicyId: 0,
        homeState: "",
        policyId: 0,
        dueDate: ""
    }
    const [detailPanelExpandedRowIds, setDetailPanelExpandedRowIds] = React.useState<GridRowId[]>([]);
    const handleDetailPanelExpandedRowIdsChange = React.useCallback((newIds: GridRowId[]) => {
        setDetailPanelExpandedRowIds(newIds.length > 1 ? [newIds[newIds.length - 1]] : newIds,);
    },
        [],
    );

    const getDetailPanelContent = React.useCallback<NonNullable<DataGridProProps['getDetailPanelContent']>>(({ row }) => <DetailPanelContent row={row} />, []);
    const getDetailPanelHeight = React.useCallback(() => 200, []);
    function DetailPanelContent({ row }: { row: NewCompletedFilingsModel }) {
        const [TaxNamAndData, setTaxNamAndData] = useState<NewCompletedFilingsModel[]>([initialdata]);
        const [isLoadingChild, setIsLoadingChild] = useState(true);
        const TaxNameAndDate = () => {

            setTaxNamAndData([])
            setIsLoadingChild(true);
            apiClient(`/PolicyDashBoard/getaxTypeandDateByCustpolicyid?customerPolicyId=${row.customerPolicyId}`,
                {
                    method: "GET",
                    headers: new Headers({
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    })
                })
                .then((responseJson) => {
                    if (!responseJson) return
                    // Do something with the response
                    if (responseJson.data != null) {

                        setTaxNamAndData(responseJson.data)
                        setIsLoadingChild(false);
                        console.log("taxData", responseJson)

                    }

                })
        }
        useEffect(() => {
            TaxNameAndDate();
        }, [row])

        const rows = [
            {
                TaxNamAndData
            }
        ];
        return (

            <Stack direction="column" spacing={1} sx={{ height: 1 }} style={{ paddingLeft: isTabletOrDown ? '50px' : '170px'}} className="hide-border-12" >

                <DataGridPro
                    loading={isLoadingChild}
                    columns={[
                        {
                            field: 'taxType',
                            type: 'string',
                            headerName: 'Tax Type',
                            flex: 1,
                            headerAlign: "left",
                            hideSortIcons: true,
                            maxWidth: 200,
                            renderHeader: (params) => (
                                <div>
                                    <span className="table-card-title" >{params.colDef.headerName}</span>
                                    <RiExpandUpDownLine />
                                </div>
                            ),
                            align: "left",
                        },

                        {
                            field: 'taxAmt', hideSortIcons: true,
                            renderHeader: (params) => (
                                <div>
                                    <span className="table-card-title" >{params.colDef.headerName}</span>
                                    <RiExpandUpDownLine />
                                </div>
                            ), type: 'string', headerName: 'Tax Amount', flex: 0.5, align: 'right', headerAlign: 'right', maxWidth: 150, renderCell: (params) => {
                                const value = params.value || '0'; // Default to '0' if value is null or undefined
                                return (
                                    <Box display="flex" alignItems="left" justifyContent="left">

                                        {formatPrice(value)}

                                    </Box>
                                )
                            }


                        },


                    ]}
                    rows={TaxNamAndData}
                    getRowId={(r) => r?.rowNum ?? 0}
                    sx={{
                        flex: 1,
                        '& .MuiDataGrid-columnHeaders': {
                            backgroundColor: '#f8fafc !important',
                            borderBottom: '2px solid #e2e8f0 !important',
                        },
                    }}
                    hideFooter
                />
            </Stack>
        );
    }

    const filterOperators = getGridStringOperators().filter(({ value }) => ['contains'].includes(value));
    const equalOperators: GridFilterOperator<any, string | number | null, any>[] = getGridStringOperators().filter(({ value }) => ['equals'].includes(value));

    const columns: GridColDef[] = [
        {
            field: 'dueDate',
            hideSortIcons: true,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'dueDate'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                    <div>
                        <span className="table-card-title">{params.colDef.headerName}</span>
                        {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                    </div>
                )
            },
            type: 'string',
            headerName: 'Filing Due Date',
            flex: 0.5,
            align: 'left',
            headerAlign: 'left',
            minWidth: 170,
            renderCell: (params) => {
                if (!params.value) {
                    return <span style={{ color: 'inherit' }}>{params.value}</span>;
                }

                let dueDate;
                try {
                    dueDate = new Date(params.value);
                    if (isNaN(dueDate.getTime())) {
                        throw new Error('Invalid date');
                    }
                } catch (error) {
                    console.error('Invalid date value:', params.value, error);
                    return <span style={{ color: 'inherit' }}>{params.value}</span>;
                }

                const currentDate = new Date();
                const isLate = dueDate < currentDate;
                const displayDate = formatUtcToLocal(params.value, 'MM/DD/YYYY');

                return (
                    <span style={{ color: isLate ? 'red' : 'inherit' }}>
                        {displayDate === 'N/A' ? params.value : displayDate}
                    </span>
                );
            }
        },
        {
            field: 'Action', flex: 0.8, minWidth: 130, filterable: false, hideSortIcons: true, 
            sortable: false,
            disableColumnMenu: true,
            headerName: "Action", headerAlign: 'center', align: 'center', disableExport: true,
            renderCell: (params) =>
            (
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', width: '100%', minWidth: 0 }}>
                    <Button
                        size="small"
                        style={{minWidth: '0px'}}
                        id={`action-options-button-${params.row.customerPolicyId}`}
                        aria-controls={anchorEl?.id === `action-options-button-${params.row.customerPolicyId}` ? `action-options-menu-${params.row.customerPolicyId}` : undefined}
                        aria-haspopup="true"
                        aria-expanded={anchorEl?.id === `action-options-button-${params.row.customerPolicyId}` ? 'true' : undefined}
                        onClick={(e) => {
                            e.stopPropagation();
                            handleClickOpenActionOptions(params.row.customerPolicyId);
                        }}
                    >
                        <MoreVertOutlinedIcon fontSize="small" />
                    </Button>
                    <Menu
                        id={`action-options-menu-${params.row.customerPolicyId}`}
                        aria-labelledby={`action-options-button-${params.row.customerPolicyId}`}
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl && anchorEl.id === `action-options-button-${params.row.customerPolicyId}`)}
                        onClose={handleCloseActionOptions}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                        }}
                        MenuListProps={{
                            'aria-labelledby': `action-options-button-${params.row.customerPolicyId}`,
                          }}
                        sx={{
                            '& .MuiMenuItem-root': {
                                fontSize: '14px',
                                padding: '8px 16px',
                            },
                        }}
                    >
                        
                        {/* <MenuItem onClick={(e) => { handleCloseActionOptions(); e.stopPropagation(); }}> */}
                        {(params.row.status !== "Missing Documents" && params.row.status !== "Ready to File" && params.row.status !== "Not Started" && params.row.status !== "Processing Documents" && params.row.policyId !== "" && params.row.policyId !== null && params.row.policyId !== undefined && params.row.status !== PolicyStatuses.FiledOnBinder) ?
                            (
                                <MenuItem onClick={(e) => { handleCloseActionOptions(); e.stopPropagation(); }}>
                                    <Link href={`/Transaction/${params.row.policyId ?? ""}/${params.row.customerPolicyId ?? ""}`} color="inherit" sx={{ textDecoration: 'none' }} target="_blank">
                                        <EditIcon fontSize="small" color="action" style={{ marginRight: 8 }} /> Check Policy
                                    </Link>
                                </MenuItem>
                            ) :
                            (params.row.status === "Waiting on Client" && params.row.policyId !== "" && params.row.policyId !== null && params.row.policyId !== undefined) ?
                                <MenuItem onClick={(e) => { handleCloseActionOptions(); e.stopPropagation(); }}>
                                    <Link href={`/Transaction/${params.row.policyId ?? ""}/${params.row.customerPolicyId ?? ""}`} color="inherit" sx={{ textDecoration: 'none' }} target="_blank">
                                        <EditIcon fontSize="small" color="action" style={{ marginRight: 8 }} /> Check Policy
                                    </Link>
                                </MenuItem>
                            : (params.row.status === "Waiting on Client") ?
                                <MenuItem onClick={(e) => { handleCloseActionOptions(); e.stopPropagation(); }}>
                                    <Link href={'/Admin/AddEditCustomerPolicyDetails/' + params.row.customerPolicyId} color="inherit" sx={{ textDecoration: 'none' }} target="">
                                        <EditIcon fontSize="small" color="action" style={{ marginRight: 8 }} /> Update Policy
                                    </Link>
                                </MenuItem>
                            :
                        ""}
                        {params.row.status === "Ready to File" ?
                        <MenuItem onClick={(e) => { handleCloseActionOptions(); e.stopPropagation(); }}>
                        <Link href={'/Admin/EditCASLaSubmissionData/' + params.row.customerPolicyId} color="inherit" sx={{ textDecoration: 'none' }} target="">
                            <EditIcon fontSize="small" color="action" style={{ marginRight: 8 }} /> Update Policy
                        </Link></MenuItem> : ""}
                        {params.row.status === "Not Started" || params.row.status === "Filed - Binder" ?
                        <MenuItem onClick={(e) => { handleCloseActionOptions(); e.stopPropagation(); }}>
                        <Link href={'/Admin/AddEditCustomerPolicyDetails/' + params.row.customerPolicyId} color="inherit" sx={{ textDecoration: 'none' }} target="">
                            <EditIcon fontSize="small" color="action" style={{ marginRight: 8 }} /> Update Policy
                        </Link> </MenuItem>: ""}
                        {/* <MenuItem onClick={(e) => { handleCloseActionOptions(); handleDocumentReubmission(params.row.customerPolicyId, params.row.status); e.stopPropagation(); }}>
                            <UploadFileIcon fontSize="small" color="action" style={{ marginRight: 8 }} /> Upload documents
                        </MenuItem> */}
                    </Menu>
                    {params.row.isClient === 1 ? (
                        <Tooltip title="Send message">
                            <IconButton
                                size="small"
                                aria-label="Send message"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    void handleSendMessage(params.row.customerPolicyId, params.row.status);
                                }}
                            >
                                <MailOutlineIcon fontSize="small" color="action" />
                            </IconButton>
                        </Tooltip>
                    ) : null}
                    <Box
                        sx={{
                            flex: '0 0 40px',
                            width: 40,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flexShrink: 0,
                        }}
                    >
                        {params.row.filerNotes && params.row.filerNotes.trim() !== "" ? (
                            <Tooltip
                                placement="top"
                                title={
                                    <div style={{
                                        maxWidth: "320px",
                                        fontSize: "16px",
                                        textAlign: "left",
                                        whiteSpace: "pre-line"
                                    }}>
                                        {params.row.filerNotes}
                                    </div>
                                }
                                arrow
                            >
                                <IconButton
                                    size="small"
                                    sx={{ color: 'rgba(255,255,255,0.9)', '&:hover': { color: '#fff', backgroundColor: 'rgba(32,153,210,0.15)' } }}
                                >
                                    <InfoOutlinedIcon fontSize="small" color="primary" />
                                </IconButton>
                            </Tooltip>
                        ) : null}
                    </Box>
                </Box>
            )
        },
        {
            field: 'agency', hideSortIcons: true,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'agency'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                    <div>
                        <span className="table-card-title">{params.colDef.headerName}</span>
                        {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                    </div>
                )
            },
            type: 'string', headerName: 'Client', flex: 0.5, minWidth: 110, align: 'left', headerAlign: 'left', filterOperators
        },
        {
            field: 'invoiceNumber', hideSortIcons: true,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'invoiceNumber'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                    <div>
                        <span className="table-card-title">{params.colDef.headerName}</span>
                        {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                    </div>
                )
            }, type: 'string', headerName: 'Invoice Number', flex: 0.6, minWidth: 175, align: 'left', headerAlign: 'left', filterOperators
        },

        {
            field: 'insuredName',
            type: 'string',
            headerName: 'Insured Name',
            flex: 0.8,
            headerAlign: "left",
            hideSortIcons: true,
            minWidth: 165,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'insuredName'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                <div>
                        <span className="table-card-title" >{params.colDef.headerName}</span>
                        {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                    </div>
                )
            },
            align: "left", filterOperators
        },
        {
            field: 'policyNumber',
            type: 'string',
            headerName: 'Policy Number',
            flex: 0.6,
            hideSortIcons: true,
            minWidth: 165,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'policyNumber'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                <div>
                    <span className="table-card-title" >{params.colDef.headerName}</span>
                        {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                    </div>
                )
            },

            headerAlign: "left",
            align: "left", filterOperators
        },
        {
            field: "homeState",
            type: "string",
            headerName: "Home State",
            flex: 0.5,
            hideSortIcons: true,
             minWidth: 140,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'homeState'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (    
                <div>
                    <span className="table-card-title" >{params.colDef.headerName}</span>
                        {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                    </div>
                )
            },
            align: "center",
            headerAlign: "left", filterOperators
        },

        {
            field: "transactionTypeName",
            type: "string",
            headerName: "Transaction Type",
            flex: 0.7, hideSortIcons: true,
             minWidth: 185,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'transactionTypeName'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                <div>
                    <span className="table-card-title" >{params.colDef.headerName}</span>
                        {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                </div>
            )
            },
            align: "left",
            headerAlign: "left", filterOperators
        },
        {
            field: 'invoiceDate', hideSortIcons: true,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'invoiceDate'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                <div>
                    <span className="table-card-title " >{params.colDef.headerName}</span>
                        {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                    </div>
                )
            }, type: 'string', headerName: 'Invoice Date', flex: 0.7, minWidth: 155, align: 'left', headerAlign: 'left', filterOperators: equalOperators,
            renderCell: (params) =>
            (
                <div>
                    {(params.row.invoiceDate != null && params.row.invoiceDate != '') ? formatUtcToLocal(params.row.invoiceDate, "MM/DD/YYYY") : ""}
                </div>
            )
        },
        {
            field: 'effectiveDate', hideSortIcons: true,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'effectiveDate'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                <div>
                    <span className="table-card-title " >{params.colDef.headerName}</span>
                        {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                    </div>
                )
            }, type: 'string', headerName: 'Policy Effective Date', flex: 0.8, minWidth: 210, align: 'left', headerAlign: 'left', filterOperators: equalOperators,
            renderCell: (params) =>
            (
                <div>
                    {(params.row.effectiveDate != null && params.row.effectiveDate != '') ? formatUtcToLocal(params.row.effectiveDate, "MM/DD/YYYY") : ""}
                </div>
            )
        },
        {
            field: 'policyExpDate', hideSortIcons: true,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'policyExpDate'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                <div>
                    <span className="table-card-title " >{params.colDef.headerName}</span>
                        {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                    </div>
                )
            }, type: 'string', headerName: 'Policy Expiration Date', minWidth: 220, flex: 0.8, align: 'left', filterOperators: equalOperators,
            headerAlign: 'left', renderCell: (params) =>
            (
                <div>
                    {(params.row.policyExpDate != null && params.row.policyExpDate != '') ? formatUtcToLocal(params.row.policyExpDate, "MM/DD/YYYY") : ""}
                </div>
            ),

        },
        {
            field: 'grossPremium',
            hideSortIcons: true,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'grossPremium'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                <div>
                    <span className="table-card-title">{params.colDef.headerName}</span>
                        {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                    </div>
                )
            },
            type: 'string',
            headerName: 'Gross Premium',
            flex: 0.5,
            align: 'right',
            headerAlign: 'right',
             minWidth: 175,
            filterOperators,
            renderCell: (params) => {
                let grossPremium = params.value || ''; // Default to an empty string if null or undefined

                // Trim any spaces and remove the dollar sign and commas
                let cleanedValue = grossPremium.replace(/[,\$]/g, "").trim();

                // If the value is in parentheses, it's negative, so handle that
                if (cleanedValue.startsWith("(") && cleanedValue.endsWith(")")) {
                    cleanedValue = "-" + cleanedValue.slice(1, -1); // Remove parentheses and add a negative sign
                }

                // Convert to number and pass to formatPrice
                const numericValue = parseFloat(cleanedValue);

                // If numericValue is a valid number, format it; otherwise, return the original string
                return isNaN(numericValue) ? grossPremium : `${formatPrice(numericValue.toString())}`;
            }
        },
        {
            field: 'status', hideSortIcons: true,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'status'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                <div>
                    <span className="table-card-title" >{params.colDef.headerName}</span>
                        {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                    </div>
                )
            },
            type: 'string', headerName: 'Status', flex: 0.4, minWidth: 140, align: 'left', headerAlign: 'left', filterOperators,
            renderCell: (params) => {
                return (
                    <div
                        className={`custom-cell`}
                        onMouseDown={(e) => {
                            e.stopPropagation();
                            const pos = outstandingGridApiRef.current?.getScrollPosition?.();
                            if (pos != null && typeof pos.left === 'number') {
                                savedHorizontalScrollRef.current = pos.left;
                            }
                        }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <MenuDropdown
                            size="medium"
                            type={'none'}
                            menuTitle={params.value}
                            items={statusOptions}
                            variant="outlined"
                            usePortal
                            onMenuClick={() => {
                                const savedLeft = savedHorizontalScrollRef.current;
                                requestAnimationFrame(() => {
                                    outstandingGridApiRef.current?.scroll?.({ left: savedLeft });
                                    requestAnimationFrame(() => {
                                        outstandingGridApiRef.current?.scroll?.({ left: savedLeft });
                                    });
                                });
                            }}
                            onItemClick={item => {
                                const rowSelection = [params.row];
                                setSelectedRows(rowSelection);
                                handleStatus(item, rowSelection);
                            }}
                            sx={getOutstandingStatusMenuSx(params.value)}
                        />
                    </div>
                );
            },
        },     
    ];

    function CustomToolbar() {
        return (
            <GridToolbarContainer  >
                <GridToolbarFilterButton className="me-3 sky-blue" />
                <GridToolbarColumnsButton className="me-3 sky-blue" />
                <GridToolbarExport className="me-3 sky-blue" />
            </GridToolbarContainer>
        );
    }

    function checkSelectedRowsForNY(rowsForAction: NewCompletedFilingsModel[]): boolean {
        if (rowsForAction.find(x => x.homeState === 'NY')) {
            if (rowsForAction.find(x => x.homeState !== 'NY')) {
                Swal.fire({
                    title: 'Warning!',
                    text: "Please select filings either specifically for New York or those that exclude New York, as there is a special rule for changing the status in New York.",
                    iconHtml: '<svg width="70" height="70" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="31" cy="31" r="31" fill="#02A4E3"/><path d="M31.0003 25.6667V31M31.0003 36.3334H31.0137M44.3337 31C44.3337 38.3638 38.3641 44.3334 31.0003 44.3334C23.6365 44.3334 17.667 38.3638 17.667 31C17.667 23.6362 23.6365 17.6667 31.0003 17.6667C38.3641 17.6667 44.3337 23.6362 44.3337 31Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
                    // showCancelButton: true,
                    confirmButtonColor: '#02A4E3',
                    // cancelButtonColor: '#d33',
                    // confirmButtonText: 'Proceed',
                    customClass: {
                        confirmButton: 'btn-radius',
                        // cancelButton: 'btn-radius',
                        popup: 'card-radius'
                    }
                })
                    .then((result) => {

                    });
                return false;
            }


        }
        return true;
    }

    function handleStatus(status: string, rowSelection?: NewCompletedFilingsModel[]) {
        const rowsForAction = rowSelection ?? selectedRows ?? [];
        if (!checkSelectedRowsForNY(rowsForAction)) {
            return;
        }
        setCurrentPolicySubStatus('');
        const isNewYorkFiling = rowsForAction.length === 1 && rowsForAction[0].homeState === 'NY' && (rowsForAction[0].transactionTypeName === 'New Business' || rowsForAction[0].transactionTypeName === 'Renewal Business')
        // Show the 'Filer Notes' modal when:
         // - status is 'Filed' and the state is New York
         if (status === 'Filed' && isNewYorkFiling) {
            (async () => {
                var response = await getCustomerPolicyDetails(rowsForAction.length ? rowsForAction[0].customerPolicyId : 0)
                 setCurrentPolicySubStatus(response);
                 handleOpenNotesDialog(status);

             })();
         }
         // Show warning if NY state exists in the selected rows
         else if (rowsForAction.find(m => m.homeState === "NY") && rowsForAction.length !== 1 && status === "Filed") {
            Swal.fire({
                 title: "",
                text: "Please select one filing for 'New York' state",
               icon: 'warning',
                confirmButtonText: "OK",
            });
             return;
         }
         // Otherwise, show a confirmation modal to update the status
         else {
            Swal.fire({
                title: 'Confirmation!',
                text: "Do you want to update customer policy's status as " + status + "?",
                iconHtml: '<svg width="70" height="70" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="31" cy="31" r="31" fill="#02A4E3"/><path d="M31.0003 25.6667V31M31.0003 36.3334H31.0137M44.3337 31C44.3337 38.3638 38.3641 44.3334 31.0003 44.3334C23.6365 44.3334 17.667 38.3638 17.667 31C17.667 23.6362 23.6365 17.6667 31.0003 17.6667C38.3641 17.6667 44.3337 23.6362 44.3337 31Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
                showCancelButton: true,
                confirmButtonColor: '#02A4E3',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Proceed',
                customClass: {
                    confirmButton: 'btn-radius',
                    cancelButton: 'btn-radius',
                    popup: 'card-radius'
                }
            })
                .then((result) => {
                    if (result.isConfirmed) {
                        setloading(true);
                        if (status !== undefined && status !== '' && status !== null) {
                            setCurrentPolicySubStatus('');
                            updateStatus(status, rowsForAction);

                        }
                    }
                });

            setloading(false);
        }
    }

    function EditToolbar() {
        const theme = useTheme();
        const isTabletOrDown = useMediaQuery(theme.breakpoints.down('md'));
        const [toolbarMenuAnchor, setToolbarMenuAnchor] = useState<null | HTMLElement>(null);
        const openToolbarMenu = Boolean(toolbarMenuAnchor);

        const handleToolbarMenuClose = () => setToolbarMenuAnchor(null);
        const handleToolbarAction = (action: 'filter' | 'columns' | 'exportCsv' | 'exportPrint') => {
            handleToolbarMenuClose();
            const api = outstandingGridApiRef.current;
            if (!api) return;
            if (action === 'filter') api.showFilterPanel();
            else if (action === 'columns') (api as any).showPreferences('columns');
            else if (action === 'exportCsv') api.exportDataAsCsv();
            else if (action === 'exportPrint') api.exportDataAsPrint();
        };

        return (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between', gap: 1.5, py: 1.5, px: 1 }}>
                <Typography variant="subtitle1" fontWeight={600} sx={{ color: '#334155', mr: 'auto', pl: 1 }}>Outstanding Filings</Typography>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    {isTabletOrDown ? (
                        <>
                            <IconButton
                                aria-label="Table options"
                                aria-controls={openToolbarMenu ? 'table-options-menu' : undefined}
                                aria-haspopup="true"
                                aria-expanded={openToolbarMenu ? 'true' : undefined}
                                onClick={(e) => setToolbarMenuAnchor(e.currentTarget)}
                                sx={{ color: '#2099d2' }}
                            >
                                <MoreVertOutlinedIcon />
                            </IconButton>
                            <Menu
                                id="table-options-menu"
                                anchorEl={toolbarMenuAnchor}
                                open={openToolbarMenu}
                                onClose={handleToolbarMenuClose}
                                MenuListProps={{ 'aria-labelledby': 'table-options-button' }}
                                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                            >
                                <MenuItem onClick={() => handleToolbarAction('filter')}>Filter</MenuItem>
                                <MenuItem onClick={() => handleToolbarAction('columns')}>Columns</MenuItem>
                                <MenuItem onClick={() => handleToolbarAction('exportCsv')}>Download as CSV</MenuItem>
                                <MenuItem onClick={() => handleToolbarAction('exportPrint')}>Print</MenuItem>
                            </Menu>
                        </>
                    ) : (
                        <CustomToolbar />
                    )}
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                    <Box sx={{ zIndex: 9 }}>
                        <MenuDropdown
                            menuTitle="Export"
                            items={user?.userRoles.split(",").includes("Super Admin") ? exportOptionsAdmin : exportOptions}
                            onItemClick={handleExport}
                            sx={{
                                textTransform: 'none',
                                fontWeight: 600,
                                backgroundColor: '#2099d2',
                                '&:hover': { backgroundColor: '#176990' },
                                px: 2,
                            }}
                            startIcon={<FileDownload />}
                        />
                    </Box>
                    {selectedRowStatus === "Ready to File" && (
                        <Button
                            variant="contained"
                            size="small"
                            onClick={handleMultipleDownload}
                            startIcon={<FileDownload />}
                            sx={{ textTransform: 'none', fontWeight: 600, backgroundColor: '#2099d2', '&:hover': { backgroundColor: '#4f46e5' } }}
                        >
                            Download
                        </Button>
                    )}
                    {selectedRowStatus === "Flagged" && (
                        <Button
                            variant="contained"
                            size="small"
                            onClick={handleSendEmail}
                            startIcon={<Email />}
                            sx={{ textTransform: 'none', fontWeight: 600, backgroundColor: '#2099d2', '&:hover': { backgroundColor: '#4f46e5' } }}
                        >
                            Send Email
                        </Button>
                    )}
                    {selectedRows?.length !== 0 && selectedRows?.length !== undefined && (
                        <Box sx={{ zIndex: 9 }}>
                            <MenuDropdown menuTitle="Status" items={statusDropdownOptions} onItemClick={handleStatus}
                                sx={{
                                    fontWeight: 600,
                                    backgroundColor: '#2099d2',
                                    '&:hover': { backgroundColor: '#176990' },
                                    px: 2,
                                }}
                            />
                        </Box>
                    )}
                </Box>
            </Box>
        );
    }

    const statusDropdownOptions = [
        'Not Started', 'Waiting on Client', 'Ready to File', 'Filed',
        // Note: Disabled intentionally until the workflows are ready.
        // 'Pending Autofile'
    ];
    if (user?.userRoles.split(",").includes("Super Admin")) {
        statusDropdownOptions.push('Removed');
    }

    const exportOptions = [
        'Short', 'Detailed'
    ]
    const exportOptionsAdmin = [
        'Short', 'Detailed', 'All'
    ]

    interface newProp {
        handleClose: () => void;
        open: boolean;
    }

    const columnsForNullDueDate: GridColDef[] = [
        { field: 'customerPolicyId', headerName: 'Customer Policy Id', width: 150, align: "center", headerAlign: "center" },
        { field: 'policyNumber', headerName: 'Policy Number', width: 150, align: "center", headerAlign: "center" },
        { field: 'insuredName', headerName: 'Insured Name', width: 150, align: "center", headerAlign: "center" },
        { field: 'dueDate', headerName: 'Due Date', width: 150, align: "center", headerAlign: "center" }
    ];

    function submit() {
        count++;
        updateStatus("Filed", editableSelectedRows);
    }
    const ShowNullFilings = ({ open, handleClose }: newProp) => {
        return (
            <Dialog open={open} onClose={handleClose} maxWidth={'lg'}>
                <DialogTitle className='card-title'>Customer Policy </DialogTitle>
                <DialogContent>
                    <span className="text-danger">Below filings cannot be updated to status "Filed" until 10 days prior to the report due date!</span>
                </DialogContent>
                <DialogContent>
                    <div style={{ height: '50vh', width: '100%' }} >
                        <DataGrid
                            rows={CustPolicyNullDueDateData ?? null}
                            columns={columnsForNullDueDate}
                            pageSize={50}
                            getRowId={(row) => row.customerPolicyId}
                            sx={{ border: "none" }}
                        />
                    </div>
                </DialogContent>
                <DialogActions>
                    <button className='btn-2 btn d-flex btn-primary search-btn' type='button' onClick={handleClose}>Cancel</button>
                    {editableSelectedRows !== undefined && editableSelectedRows !== null && editableSelectedRows?.length > 0 ?
                        <button className='btn btn-primary active-btn-blue ' type='button' onClick={submit}>Update Rest</button>
                        : ""
                    }
                </DialogActions>
            </Dialog>
        );
    };

    function CustomColumnMenu(props: GridColumnMenuProps) {
        const { hideMenu, currentColumn, color, ...other } = props;

        return (
            <GridColumnMenuContainer
                hideMenu={hideMenu}
                currentColumn={currentColumn}
                {...other}
            >
                <SortGridMenuItems onClick={hideMenu} column={currentColumn} />
                <GridFilterMenuItem onClick={hideMenu} column={currentColumn} />
                <HideGridColMenuItem onClick={hideMenu} column={currentColumn} />
                <GridColumnsMenuItem onClick={hideMenu} column={currentColumn} />
            </GridColumnMenuContainer>
        );
    }

    return (
        <Box sx={{ height: { xs: "100vh", sm: "calc(100vh - 300px)" }, display: "flex", flexDirection: "column", width: "100%", borderRadius: '12px', overflow: 'hidden', boxShadow: '0 4px 24px rgba(15, 23, 42, 0.08), 0 1px 3px rgba(15, 23, 42, 0.06)', border: '1px solid #e2e8f0', backgroundColor: '#ffffff' }}>
            {loading && <LinearProgress sx={{ backgroundColor: "#2099d2" }} />}
            <div style={{ flex: '1 1 0%', overflow: 'auto' }}>
            <DataGridPro
                apiRef={outstandingGridApiRef}
                rowHeight={60}
                getRowId={(r) => r?.customerPolicyId}
                rows={NewCompletedFilingsCL?.getCompletedFilings_Respdata}
                columns={columns}
                getDetailPanelHeight={getDetailPanelHeight}
                getDetailPanelContent={getDetailPanelContent}
                loading={isLoading}
                pageSize={pageSize}
                pagination
                rowCount={NewCompletedFilingsCL?.totalCount}
                paginationMode="server"
                onPageChange={(newPage) => setCurrentPage(newPage + 1)}
                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}

                filterMode="server"
                onFilterModelChange={(newFilterModel: any) => setFilterModel(newFilterModel)}

                detailPanelExpandedRowIds={detailPanelExpandedRowIds}
                onDetailPanelExpandedRowIdsChange={handleDetailPanelExpandedRowIdsChange}

                sortingMode="server"
                onSortModelChange={(newSortModel: any) => setSortModel(newSortModel)}
                sortModel={sortModel}
                sortingOrder={['desc', 'asc']}
                rowsPerPageOptions={getRowsPerPageOptions(NewCompletedFilingsCL?.totalCount, pageSize)}

                rowModesModel={rowModesModel}
                checkboxSelection={
                    user?.userRoles.split(",").includes("Super Admin") ||
                        user?.userRoles.split(",").includes("MISC Filer") ||
                        user?.userRoles.split(",").includes("MISC State Reporter")
                        ? true : false
                }
                getRowClassName={(params) => {
                    const isClient =  Number(params.row.isClient ) === 1; 
                    return isClient ? `custom-row-bg-${params.row.isDocsUploaded}` : 'without-documents';
                }}
                onSelectionModelChange={user?.userRoles.split(",").includes("Super Admin") ||
                    user?.userRoles.split(",").includes("MISC Filer") ||
                    user?.userRoles.split(",").includes("MISC State Reporter")
                    ? (newRowSelectionModel) => {
                        onRowsSelectionHandler(newRowSelectionModel);
                    } : undefined}
                selectionModel={selectedRows?.map((row) => row.customerPolicyId) as GridRowId[]}
                disableSelectionOnClick
                initialState={isTabletOrDown ? undefined : { pinnedColumns: { left: ['dueDate'] } }}

                components={{
                    Toolbar: EditToolbar,
                    ColumnMenu: CustomColumnMenu
                }}

                sx={{
                    fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
                    border: 'none',
                    fontSize: '14px',
                    color: '#475569',
                    backgroundColor: '#ffffff',
                    "& .MuiDataGrid-detailPanel": {
                        zIndex: 'auto',
                    },
                    // Match MUI X defaults; stay well below theme.zIndex.modal (1300) so dialogs/popovers cover pinned cells.
                    '& .MuiDataGrid-pinnedColumns--left': {
                        zIndex: 1,
                    },
                    '& .MuiDataGrid-pinnedColumnHeaders': {
                        zIndex: 2,
                    },
                    '& .custom-row-bg-green .MuiDataGrid-cell': {
                        backgroundColor: '#a2dda2',
                    },
                    '& .custom-row-bg-green:hover .MuiDataGrid-cell': {
                        backgroundColor: '#81c781',
                    },
                    '& .custom-row-bg-yellow .MuiDataGrid-cell': {
                        backgroundColor: '#fff9ad',
                    },
                    '& .custom-row-bg-yellow:hover .MuiDataGrid-cell': {
                        backgroundColor: '#f0e68c',
                    },
                    '& .custom-row-bg-red .MuiDataGrid-cell': {
                        backgroundColor: '#f8d7da',
                    },
                    '& .custom-row-bg-red:hover .MuiDataGrid-cell': {
                        backgroundColor: '#f1c2c9',
                    },
                    "& .MuiDataGridPro-columnHeaderTitle": {
                        whiteSpace: 'normal',
                        lineHeight: 1.35,
                        fontWeight: 600,
                        fontSize: '12px',
                        letterSpacing: '0.05em',
                        textTransform: 'uppercase',
                        color: '#64748b',
                    },
                    "& .MuiDataGrid-columnHeaders": {
                        backgroundColor: '#f8fafc',
                        borderBottom: '2px solid #e2e8f0',
                        borderTop: '2px solid #e2e8f0',
                        minHeight: '52px !important',
                        maxHeight: '52px !important',
                    },
                    "& .MuiDataGrid-columnHeader": {
                        "&:focus, &:focus-within": { outline: 'none' },
                    },
                    "& .MuiDataGrid-row": {
                        transition: 'background-color 0.15s ease',
                        "&:nth-of-type(even)": {
                            backgroundColor: '#fafbfc',
                        },
                        "&:hover": {
                            backgroundColor: '#f1f5f9 !important',
                        },
                        "&.Mui-selected": {
                            backgroundColor: '#ebf5fa !important',
                            "&:hover": {
                                backgroundColor: '#dbeef7 !important',
                            },
                        },
                    },
                    "& .MuiDataGrid-cell": {
                        borderBottom: '1px solid #f1f5f9',
                        fontSize: '14px',
                        color: '#334155',
                        "&:focus": { outline: 'none' },
                    },
                    "& .MuiDataGrid-virtualScroller": {
                        border: 'none',
                    },
                    "& .MuiDataGrid-main": {
                        border: 'none',
                    },
                    "& .MuiDataGrid-footerContainer": {
                        borderTop: '1px solid #e2e8f0',
                        backgroundColor: '#f8fafc',
                        minHeight: 56,
                    },
                    "& .MuiTablePagination-root": {
                        color: '#64748b',
                        fontSize: '13px',
                    },
                    "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows": {
                        marginBottom: 0,
                    },
                    "& .MuiTablePagination-select": {
                        fontSize: '13px',
                        borderRadius: '6px',
                        border: '1px solid #e2e8f0',
                    },
                    "& .MuiIconButton-root": {
                        color: '#64748b',
                        "&:hover": {
                            backgroundColor: '#f1f5f9',
                            color: '#475569',
                        },
                    },
                    "& .MuiCheckbox-root": {
                        color: '#94a3b8',
                        "&.Mui-checked": {
                            color: '#2099d2',
                        },
                    },
                }}
            />
            </div>
            <PolicyDocumentsPopup
                handleClose={handleClose}
                Open={Open}
                documentList={Formdata}
            />
            <PolicyErrorPopup
                handleClose={handleClose}
                Open={OpenError}
                documentList={ErrorFormdata}
            />
            <AddDocument
                open={OpenDocResubmission}
                handleClose={handleCloseDocumentUpload}
                customerPolicyId={custPolId}
                currentUser={user ?? undefined}
                viewOnly={false}
            />
            {/* {OpenMessageTab ? <Messages open={OpenMessageTab} handleClose={handleClose} custPolicyID={custPolId} />  : ""} */}

            {openNotesDialog && <FilerNotes
                open={!!openNotesDialog}
                handleClose={handleCloseNotesDialog}
                handleSubmit={handleSubmitNotes}
                selectedRows={selectedRows}
                currentStatus={openNotesDialog}
                currentPolicySubStatus={currentPolicySubStatus}
            />}
            <ShowNullFilings handleClose={handleClose} open={openPolicyDueDateNullDialog} />
        </Box>
    );
};

